import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';
import {useField} from 'formik';
import Label from 'shared/components/label';
import FormikDropdown from 'src/components/formik-dropdown';
import useAsyncState from 'src/hooks/use-async-state/use-async-state';
import AssetService from 'src/services/AssetService/AssetService';

const CitizenshipInput = () => {
  const [usCitizenOrResident] = useField('usCitizenOrResident');

  const [countries] = useAsyncState(() => AssetService.getCountryOptions({includeUs: false}), []);

  return (
    <>
      <FormikRadioButtons
        name="usCitizenOrResident"
        options={[
          {value: 'true', label: 'Yes'},
          {value: 'false', label: 'No'},
          {value: 'decline', label: 'Prefer not to answer'},
        ]}
        legendText={
          <>
            <p>Are you a US citizen or permanent resident?</p>
            <span>
              Some scholarships are for US. students and others are for international students. This
              information is only shared with colleges.
            </span>
          </>
        }
      />
      {usCitizenOrResident.value === 'false' && (
        <Label>
          What is your primary country of citizenship?
          <FormikDropdown name="countryOfCitizenship" options={countries} />
        </Label>
      )}
    </>
  );
};

export default CitizenshipInput;
